export const arrayToSentence = (arr) => {
	if (arr.length === 1) return arr[0];
	else if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
	return arr.slice(0, arr.length - 1).join(', ') + ', and ' + arr.slice(-1);
};
